import styled from 'styled-components';
import BasicButton from '../Basic/BasicButton';

const SecondaryButton = styled(BasicButton)`
  background-color: var(--background-app);
  color: var(--foreground-form);
`;

export default SecondaryButton;
